import { Component, OnInit, ViewChild,HostListener } from '@angular/core';
import { HelperService } from '../helper.service';
import { Subject } from 'rxjs/Subject';
import { Http, Response,Headers } from '@angular/http';
import 'rxjs/add/operator/map';
import { DataTableDirective } from 'angular-datatables';
import {MatSnackBar} from '@angular/material';
import { NgForm } from '@angular/forms';
import { Router,ActivatedRoute, Params } from '@angular/router';
import {CookieService} from 'angular2-cookie/core';

@Component({
  selector: 'app-profile',
  templateUrl: './profile.component.html',
  styleUrls: ['./profile.component.css'],
   providers: [HelperService,CookieService] 
})
export class ProfileComponent implements OnInit {
  // 	@HostListener('window:beforeunload', ['$event'])
//   unloadHandler(event: Event) {
//   localStorage.removeItem('access_token');
//   localStorage.removeItem('navigateroute');
// }
   @ViewChild("fileInput") fileInput;
  dtOptions: DataTables.Settings = {};
  dtTrigger: Subject<any> = new Subject();
  datas:any=[];
  dtElement: DataTableDirective;
 loader=false;
  user_id;
   roles;
   user_token= localStorage.getItem('access_token');
  private headers: Headers = new Headers({
  'Accept': 'application/json',
  'Authorization': "Bearer "+this.user_token
});
  constructor(private helper:HelperService,private http:Http,private snackbar: MatSnackBar,private router: Router,private cookie:CookieService) {
  this.user_id=cookie.get('user_id');

  }

  ngOnInit() {
    //let user=this.cookie.get('user_id');
  	this.dtOptions = {
      pagingType: 'full_numbers',
      pageLength: 10
    };
    
    this.http.get(this.helper.base_url+'http/get/users/1',{ headers: this.headers })
    
    .subscribe(data => {
      this.datas = JSON.parse(data['_body']).users[0];
      this.roles = JSON.parse(data['_body']).roles;
      
     
    });
  }

 

 update_form(addForm: NgForm){
  let body = new FormData();
  let fi = this.fileInput.nativeElement;
  this.loader=true;
  body.append('email', addForm.value.email);
  body.append('name', addForm.value.name);
  body.append('password', addForm.value.password);
  body.append('role_id', this.datas.role_id);
  body.append('image', fi.files[0]);

   this.http.post(this.helper.base_url+'http/update/user', body,{ headers: this.headers })
   .subscribe(
     (res) => {
     this.loader=false;
     let data= JSON.parse(res['_body'] ) ;
     //console.log(data);
     this.router.navigate(["/dashboard"]);
      if(data.pic!=''){
         this.cookie.put('user_image',data.pic);
      }
    
     }, //For Success Response
      err => {console.error(err)} //For Error Response);
   );
 }

  refresh(val=false,msg=''){
  this.snackbar.open(msg, null, {
    duration:5000,
      extraClasses:'success-snackbar',
      verticalPosition:'top'
    });
  this.router.navigateByUrl('/redirect', {skipLocationChange: true}).then(()=>
  this.router.navigate(["/dashboard"]));
  
      
 }

}



// WEBPACK FOOTER //
// ./src/app/profile/profile.component.ts